import React from "react";
import "./index.css";
import { ListGroup, ListGroupItem } from "reactstrap";
import { FaFilePdf } from "react-icons/fa";
const Detaje = ({ dokumenta }) => {
  let categories = {};
  dokumenta.map(dokument => {
    var kategori = dokument.TipDok.Emri;
    if (categories[kategori]) {
      categories[kategori].push(dokument);
    } else {
      categories[kategori] = [];
      categories[kategori].push(dokument);
    }
    return true;
  });

  return (
    <ListGroup>
      {Object.values(categories).map(category => {
        return (
          <>
            <ListGroupItem size="sm" active tag="a" href="#" action>
              {category[0].TipDok.Emri}
            </ListGroupItem>
            {category.map(dokument => {
              return (
                <ListGroupItem tag="a">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <b>{dokument.Emri}</b>
                    <div
                      style={{
                        width: "20%",
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center"
                      }}
                    >
                      <FaFilePdf size={25} />
                    </div>
                  </div>
                </ListGroupItem>
              );
            })}
          </>
        );
      })}
    </ListGroup>
  );
};

export default Detaje;
